const userDataReducer = (userData = {}, action) => {
    switch(action.type){
        case 'SET_USER_DATA':
            userData = action.data
            return userData;
        default:
            return userData;
    }
}

export default userDataReducer